import { defineComponent, markRaw } from 'vue';
// The fixed stack that the rewind vote banner teleports into, and the spacer
// in the page's flow that keeps the page from sliding under them.
export default defineComponent({
    name: 'BannerStack',
    data() {
        return { height: 0, observer: undefined };
    },
    methods: {
        resize(entries) {
            this.height = Math.ceil(entries[entries.length - 1].contentRect.height);
        },
    },
    mounted() {
        if (typeof ResizeObserver === 'undefined') {
            return;
        }
        this.observer = markRaw(new ResizeObserver((entries) => this.resize(entries)));
        this.observer.observe(this.$refs.stack);
    },
    unmounted() {
        this.observer?.disconnect();
    },
});
